import { useTRPC } from "@/trpc/client";
import { useMutation, useQueryClient } from "@tanstack/react-query";

export default function useUpdateBusiness() {
  const trpc = useTRPC();
  const queryClient = useQueryClient();

  return useMutation({
    ...trpc.business.update.mutationOptions(),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [["business", "get"]] });
      queryClient.invalidateQueries({ queryKey: [["business", "list"]] });
    },
  });
}
